@if (content(); as content) {
    <div class="event-modal">
        <div class="modal-header event-modal-header">
            <h2
                id="venue-storefront-event-modal-title"
                class="modal-title h5 fw-semibold m-0"
            >
                {{ content.kind === 'event' ? content.event.displayName : content.reason.displayName }}
            </h2>
            <button
                type="button"
                class="event-modal-close"
                aria-label="Close"
                data-testid="close-event-modal"
                (click)="dismiss()"
            >
                <span>Close</span>
                <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
        </div>

        <div class="modal-body event-modal-body">
            @if (imageUrl(); as imageUrl) {
                <div class="event-modal-media">
                    <img
                        [ngSrc]="imageUrl"
                        class="event-modal-image"
                        width="582"
                        height="240"
                        [alt]="content.kind === 'event' ? content.event.displayName : content.reason.displayName"
                    />
                </div>
            }

            <div class="event-modal-content">
                <div
                    class="event-modal-details"
                    [class.event-modal-details--reason]="content.kind === 'reason'"
                    [attr.aria-label]="content.kind === 'event' ? 'Event details' : 'Reason details'"
                >
                    <div class="event-modal-detail">
                        <img
                            ngSrc="assets/calendar_small.svg"
                            class="event-detail-icon"
                            width="20"
                            height="20"
                            alt=""
                            aria-hidden="true"
                        />
                        <span>
                            <span class="visually-hidden">Date: </span>
                            {{ content.date | date:'EEEE d MMMM' }}
                        </span>
                    </div>

                    @if (content.kind === 'event') {
                        <div
                            class="event-modal-detail"
                            data-testid="event-time"
                        >
                            <img
                                ngSrc="assets/clock_small.svg"
                                class="event-detail-icon"
                                width="20"
                                height="20"
                                alt=""
                                aria-hidden="true"
                            />
                            <span>
                                <span class="visually-hidden">Time: </span>
                                @if (startDateTime(); as startDateTime) {
                                    {{ startDateTime | date:'shortTime' }}
                                    @if (endDateTime(); as endDateTime) {
                                        @if (startDateTime.getTime() !== endDateTime.getTime()) {
                                            &ndash; {{ endDateTime | date:'shortTime' }}
                                        }
                                    }
                                } @else {
                                    All day
                                }
                            </span>
                        </div>

                        <div class="event-modal-detail align-items-start">
                            <img
                                ngSrc="assets/deposit_small.svg"
                                class="event-detail-icon"
                                width="20"
                                height="20"
                                alt=""
                                aria-hidden="true"
                            />
                            <div class="vstack gap-1">
                                <span class="visually-hidden">Charges: </span>
                                @if (content.event.depositAmount; as depositAmount) {
                                    <span>
                                        {{ null | currencyUnit : depositAmount : content.currencyCode }}
                                        per person
                                    </span>
                                }
                                @if (content.event.depositFlatFeeAmount; as depositFlatFeeAmount) {
                                    <span>
                                        {{ null | currencyUnit : depositFlatFeeAmount : content.currencyCode }}
                                        per booking
                                    </span>
                                }
                                @if (content.event.cancellationChargeAmount; as cancellationChargeAmount) {
                                    <span>
                                        {{ null | currencyUnit : cancellationChargeAmount : content.currencyCode }}
                                        cancellation charge per person
                                    </span>
                                }
                                @if (content.event.cancellationChargePartyAmount; as cancellationChargePartyAmount) {
                                    <span>
                                        {{ null | currencyUnit : cancellationChargePartyAmount : content.currencyCode }}
                                        cancellation charge per booking
                                    </span>
                                }
                                @if (!hasCharges()) {
                                    <span>No charges</span>
                                }
                            </div>
                        </div>
                    } @else {
                        @let configuredOpeningTimes = content.reason.displayedOpeningTimes;
                        @let scheduledOpeningTimes = content.reason.scheduleRules.length > 0
                            ? (content.reason | reasonTime : content.date)
                            : null;
                        @let openingTimes = configuredOpeningTimes ?? scheduledOpeningTimes;
                        @if (openingTimes) {
                            <div
                                class="event-modal-detail"
                                data-testid="reason-time"
                            >
                                <img
                                    ngSrc="assets/clock_small.svg"
                                    class="event-detail-icon"
                                    width="20"
                                    height="20"
                                    alt=""
                                    aria-hidden="true"
                                />
                                <span>
                                    <span class="visually-hidden">Time: </span>
                                    {{ openingTimes }}
                                </span>
                            </div>
                        }
                    }
                </div>

                @if (description(); as description) {
                    <div
                        class="event-modal-description quill-flush"
                    >
                        <quill-view class="d-block" format="html" theme="bubble" [sanitize]="true" [content]="description"></quill-view>
                    </div>
                }

                @if (content.kind === 'event' && content.event.notReservableOnline) {
                    @if (content.event.notReservableOnlineMessage; as message) {
                        <div
                            class="event-modal-description event-modal-not-reservable-message"
                            data-testid="event-not-reservable-message"
                            [innerHTML]="message"
                        ></div>
                    }
                }
            </div>
        </div>

        @if (
            bookingSelectionEnabled()
            && (content.kind === 'reason' || !content.event.notReservableOnline)
        ) {
            <div class="modal-footer event-modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    data-testid="continue-with-booking-choice"
                    (click)="selectAndContinue()"
                >
                    Select &amp; Continue
                </button>
            </div>
        }
    </div>
}
